import Vue from "vue";
import Antd from 'ant-design-vue';
Vue.use(Antd);
/*import {
    Button,
    FormModel,
    Form,
    Input,
    Layout,
    PageHeader,
    Space,
    Avatar,
    Dropdown,
    Menu,
    Icon,
    Select,
    Table,
    Pagination,
    Tag,
    Tabs,
    Popconfirm,
    Divider,
    Modal,
    Drawer,
    Calendar,
    Popover,
    TimePicker,
    DatePicker,
    Badge
} from 'ant-design-vue';

Vue.use(Button);
Vue.use(Form);
Vue.use(FormModel);
Vue.use(Input);
Vue.use(Layout);
Vue.use(PageHeader);
Vue.use(Space);
Vue.use(Avatar);
Vue.use(Dropdown);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(Select);
Vue.use(Table);
Vue.use(Pagination);
Vue.use(Tag);
Vue.use(Tabs);
Vue.use(Popconfirm);
Vue.use(Divider);
Vue.use(Modal);
Vue.use(Drawer);
Vue.use(Calendar);
Vue.use(Popover);
Vue.use(TimePicker);
Vue.use(DatePicker);
Vue.use(Badge);
*/